import NotFound from '../components/NotFound';

export default function Team() {
  return <NotFound pageName="Meet Our Team" />;
}
